import { TFunction } from 'i18next';
import { extractErrorMessage } from 'utils/extractErrorMessage';
import IValidateResponse from 'types/contract/IValidateResponse';

/**
 * Contract validation results carry either a translation key ("[CONTRACTS] …") or, for the minors break rules,
 * a sentence the API already resolved with the agency's configured values (US 125). Only keys go through t():
 * a resolved sentence can contain "." or ":", which i18next treats as key and namespace separators.
 */
export const translateValidationMessage = (t: TFunction, value: string | null | undefined): string => {
  if (!value) return '';
  return value.startsWith('[') ? t(value) : value;
};

/** The resolved `message` when the API sent one, otherwise the translation key. */
export const getValidationMessage = (response: Pick<IValidateResponse, 'message' | 'messageTranslationKey'>): string =>
  response.message || response.messageTranslationKey;

/**
 * For an ErrorResponse body, the API's resolved `message` wins over the `error` key, so a minors break sentence keeps
 * the agency's configured values. Anything else falls back to extractErrorMessage.
 */
export const getErrorResponseMessage = (error: unknown): string => {
  const message = (error as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  return typeof message === 'string' && message.trim() ? message : extractErrorMessage(error);
};
